/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The InvitedUserInfoDto model module.
 * @module model/InvitedUserInfoDto
 * @version v0
 */
class InvitedUserInfoDto {
    /**
     * Constructs a new <code>InvitedUserInfoDto</code>.
     * @alias module:model/InvitedUserInfoDto
     */
    constructor() { 
        
        InvitedUserInfoDto.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>InvitedUserInfoDto</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/InvitedUserInfoDto} obj Optional instance to populate.
     * @return {module:model/InvitedUserInfoDto} The populated <code>InvitedUserInfoDto</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new InvitedUserInfoDto();

            if (data.hasOwnProperty('invitationId')) {
                obj['invitationId'] = ApiClient.convertToType(data['invitationId'], 'Number');
            }
            if (data.hasOwnProperty('userId')) {
                obj['userId'] = ApiClient.convertToType(data['userId'], 'Number');
            }
            if (data.hasOwnProperty('username')) {
                obj['username'] = ApiClient.convertToType(data['username'], 'String');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('surname')) {
                obj['surname'] = ApiClient.convertToType(data['surname'], 'String');
            }
            if (data.hasOwnProperty('email')) {
                obj['email'] = ApiClient.convertToType(data['email'], 'String');
            }
            if (data.hasOwnProperty('invitedAt')) {
                obj['invitedAt'] = ApiClient.convertToType(data['invitedAt'], 'Date');
            }
            if (data.hasOwnProperty('acceptedAt')) {
                obj['acceptedAt'] = ApiClient.convertToType(data['acceptedAt'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>InvitedUserInfoDto</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>InvitedUserInfoDto</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['username'] && !(typeof data['username'] === 'string' || data['username'] instanceof String)) {
            throw new Error("Expected the field `username` to be a primitive type in the JSON string but got " + data['username']);
        }
        // ensure the json data is a string
        if (data['name'] && !(typeof data['name'] === 'string' || data['name'] instanceof String)) {
            throw new Error("Expected the field `name` to be a primitive type in the JSON string but got " + data['name']);
        }
        // ensure the json data is a string
        if (data['surname'] && !(typeof data['surname'] === 'string' || data['surname'] instanceof String)) {
            throw new Error("Expected the field `surname` to be a primitive type in the JSON string but got " + data['surname']);
        }
        // ensure the json data is a string
        if (data['email'] && !(typeof data['email'] === 'string' || data['email'] instanceof String)) {
            throw new Error("Expected the field `email` to be a primitive type in the JSON string but got " + data['email']);
        }

        return true;
    }


}



/**
 * ID de la invitación para permitir eliminación
 * @member {Number} invitationId
 */
InvitedUserInfoDto.prototype['invitationId'] = undefined;

/**
 * @member {Number} userId
 */
InvitedUserInfoDto.prototype['userId'] = undefined;

/**
 * @member {String} username
 */
InvitedUserInfoDto.prototype['username'] = undefined;

/**
 * @member {String} name
 */
InvitedUserInfoDto.prototype['name'] = undefined;

/**
 * @member {String} surname
 */
InvitedUserInfoDto.prototype['surname'] = undefined;

/**
 * @member {String} email
 */
InvitedUserInfoDto.prototype['email'] = undefined;

/**
 * @member {Date} invitedAt
 */
InvitedUserInfoDto.prototype['invitedAt'] = undefined;

/**
 * @member {Date} acceptedAt
 */
InvitedUserInfoDto.prototype['acceptedAt'] = undefined;






export default InvitedUserInfoDto;

